import React from 'react';
import {
  IconCheckCircle,
  IconCloseCircleFilled,
  IconCached,
} from 'takeat-design-system-ui-kit';
import { BadgeContainer, IconWrapper, Label } from './styles';

const StatusBadge = ({ status }) => {
  const getStatusText = () => {
    switch (status) {
      case 'open':
        return 'Conectado';
      case 'created':
        return 'Conectando';
      case 'close':
        return 'Desconectado';
      default:
        return 'Status desconhecido';
    }
  };

  const getStatusIcon = () => {
    switch (status) {
      case 'open':
        return <IconCheckCircle />;
      case 'created':
        return <IconCached />;
      case 'close':
        return <IconCloseCircleFilled />;
      default:
        return <IconCloseCircleFilled />;
    }
  };

  const text = getStatusText();
  const icon = getStatusIcon();

  return (
    <BadgeContainer status={status}>
      <IconWrapper status={status}>{icon}</IconWrapper>
      <Label status={status}>{text}</Label>
    </BadgeContainer>
  );
};

export default StatusBadge;
